import { Grid } from "@material-ui/core";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";


function Copyright() {
  return (
    <React.Fragment>
      {/* {'© '} */}
      {/* <Link
        color="inherit"
        target="_blank"
        href="https://nightowlglasses.com"
        style={{ color: "white" }}
      >
        Powered by Night Owl Glasses
      </Link>{" "} */}
    </React.Fragment>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    // backgroundColor: 'white',
    bottom: 0,
    margin: 0,
  },
  container: {
    marginTop: theme.spacing(15),
    marginBottom: theme.spacing(16),
    display: "flex",
  },

  icons: {
    display: "flex",
  },

  list: {
    margin: 0,
    listStyle: "none",
    padding: 0,
  },

  language: {
    marginTop: theme.spacing(1),
    width: 150,
  },
}));

const Footer = () => {
  const classes = useStyles();

  return (
    <Typography component="footer" className={classes.root}>
      <Container className={classes.container}>
        <Grid
          container
          direction="column"
          justify="center"
          alignItems="center"
          className={classes.iconsWrapper}
        >
          <Grid item>
            <Copyright />
          </Grid>
          {/* <Grid item>
            <Button target="_blank" href="https://nightowlglasses.com">
              <img
                src={NightOwlLogo}
                style={{ height: "3em", width: "3em" }}
              ></img>
            </Button>
          </Grid> */}
        </Grid>
      </Container>
    </Typography>
  );
};

export default Footer;
